export default "__VITE_ASSET__BmAPcFml__"